module.exports = __webpack_public_path__ + "img/cake_gift_v2.f0b783c7.svg";